<h2 class="portal-section-title">{{ 'research.portal.topten.title' | translate }}</h2>
<mulo-centered-block-layout class="featured">
  <div class="featured-content">
    <mat-tab-group (selectedTabChange)="onTabChanged($event)" [mat-stretch-tabs]="false" mat-align-tabs="center">
      <mat-tab [label]="tabOneLabel | translate">
        <swiper
          [autoplay]="false"
          [isDataChanged]="tabChanged$ | async"
          [navigation]="{}"
          [pagination]="{ clickable: true }"
          [slidesPerView]="media.is('gt-sm') ? 3 : 1"
          [spaceBetween]="55"
          >
          @for (asset of tabOneAssets; track asset) {
            <ng-template swiperSlide>
              <exl-citation-brief
                [authors]="getAuthors(asset.creators)"
                [hoverable]="false"
                [queryParams]="getFullAssetPageQueryParams()"
                [router]="asset.permalink"
                [titleClickable]="true"
                [title]="asset.title"
                [titleHeaderLevel]="3"
                [type]="'portal.' + asset.resourceType"
                >
                @if (asset.description) {
                  <mulo-expandable
                    [collapseLabel]="'research.results.description.collapse' | translate"
                    [ratio]="3"
                    buttonPosition="right"
                    class="abstract"
                    expandLabel="...{{ 'research.results.description.expand' | translate }}"
                    >
                    <p [innerHTML]="asset.description | htmlSanitize"></p>
                  </mulo-expandable>
                }
              </exl-citation-brief>
            </ng-template>
          }
        </swiper>
      </mat-tab>
      @if (topTenOptions.length >= 2) {
        <mat-tab [label]="tabTwoLabel | translate">
          <swiper
            [autoplay]="false"
            [isDataChanged]="tabChanged$ | async"
            [navigation]="{}"
            [pagination]="{ clickable: true }"
            [slidesPerView]="media.is('gt-sm') ? 3 : 1"
            [spaceBetween]="50"
            >
            @for (asset of tabTwoAssets; track asset) {
              <ng-template swiperSlide>
                <exl-citation-brief
                  [authors]="getAuthors(asset.creators)"
                  [hoverable]="false"
                  [queryParams]="getFullAssetPageQueryParams()"
                  [router]="asset.permalink"
                  [titleClickable]="true"
                  [title]="asset.title"
                  [titleHeaderLevel]="3"
                  [type]="'portal.' + asset.resourceType"
                  >
                  @if (asset.description) {
                    <mulo-expandable
                      [collapseLabel]="'research.results.description.collapse' | translate"
                      [ratio]="3"
                      buttonPosition="right"
                      class="abstract"
                      expandLabel="...{{ 'research.results.description.expand' | translate }}"
                      >
                      <p [innerHTML]="asset.description | htmlSanitize"></p>
                    </mulo-expandable>
                  }
                </exl-citation-brief>
              </ng-template>
            }
          </swiper>
        </mat-tab>
      }
      @if (topTenOptions.length >= 3) {
        <mat-tab [label]="tabThreeLabel | translate">
          <swiper
            [autoplay]="false"
            [isDataChanged]="tabChanged$ | async"
            [navigation]="{}"
            [pagination]="{ clickable: true }"
            [slidesPerView]="media.is('gt-sm') ? 3 : 1"
            [spaceBetween]="50"
            >
            @for (asset of tabThreeAssets; track asset) {
              <ng-template swiperSlide>
                <exl-citation-brief
                  [authors]="getAuthors(asset.creators)"
                  [hoverable]="false"
                  [queryParams]="getFullAssetPageQueryParams()"
                  [router]="asset.permalink"
                  [titleClickable]="true"
                  [title]="asset.title"
                  [titleHeaderLevel]="3"
                  [type]="'portal.' + asset.resourceType"
                  >
                  @if (asset.description) {
                    <mulo-expandable
                      [collapseLabel]="'research.results.description.collapse' | translate"
                      [ratio]="3"
                      buttonPosition="right"
                      class="abstract"
                      expandLabel="...{{ 'research.results.description.expand' | translate }}"
                      >
                      <p [innerHTML]="asset.description | htmlSanitize"></p>
                    </mulo-expandable>
                  }
                </exl-citation-brief>
              </ng-template>
            }
          </swiper>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</mulo-centered-block-layout>
